<template>
    <b-form-group :label="showLabel ? $t('modules.modules') : null" label-for="modules">
        <Select
            class="mb-2"
            :state="state"
            :selected="editOption"
            :options="editOptions"
            :disabled="disabled"
            @changeValue="$emit('update:editOption', $event)"
        />
        <b-form-checkbox-group
            id="modules"
            :options="options"
            :value="value"
            :state="state"
            @change="$emit('update:value', $event)"
        />
        <b-form-invalid-feedback id="modules">
            <span>
                {{ $t('usersBulkEdit.messages.selectTheDesiredModules') }}
            </span>
        </b-form-invalid-feedback>
    </b-form-group>
</template>

<script>
import defaultModules from '@/data/bulk-edit-modules'
import modulesEditOptions from '@/data/modulesUpdateOptions'
import { Select } from '@/views/components/selects'
import _ from 'lodash'

export default {
    name: 'Modules',
    components: {
        Select,
    },
    props: ['value', 'disabled', 'state', 'showLabel', 'editOption'],
    data() {
        return {
            selected: [],
            options: [],
            defaultModules,
            editOptions: modulesEditOptions,
            loading: true,
        }
    },
    mounted() {
        const defaultOption = this.editOptions.find((option) => option.isDefault)
        this.$emit('update:editOption', defaultOption)
        this.getAvailableModules()
    },
    methods: {
        getAvailableModules() {
            const isAdminOrGod = this.currentUser.has_roles.filter((role) => {
                if (this.isAdminOrGodOrLocalAdministrator.includes(role)) return role
            })

            if (isAdminOrGod.length) {
                return (this.options = this.mapperToOptions(this.currentUser.has_modules))
            }

            const modules = []
            this.currentUser.has_roles.filter((role) => {
                if (role == 'is_values_master') {
                    modules.push(this.valuesMasterAvailableModules)
                }

                if (role == 'is_target_master') {
                    modules.push(this.targetMasterAvailableModules)
                }
            })

            return (this.options = this.mapperToOptions(
                _.intersection(this.currentUser.has_modules, this.getFormatModules(modules))
            ))
        },
        mapperToOptions(modules) {
            return modules
                .filter((module) => {
                    return !['has_enps', 'has_strategy', 'has_quiz'].includes(module)
                })
                .map((module) => {
                    return {
                        text: this.defaultModules[module],
                        value: module,
                    }
                })
        },
        getFormatModules(modules) {
            const availableModules = []

            modules.forEach((element) => {
                element.filter((module) => {
                    availableModules.push(module)
                })
            })
            return availableModules
        },
    },
    computed: {
        currentUser() {
            return this.$store.state.currentUser.user
        },
        isAdminOrGodOrLocalAdministrator() {
            return ['administrator', 'god', 'local_administrator']
        },
        valuesMasterAvailableModules() {
            return ['has_value', 'has_talk', 'has_pdi']
        },
        targetMasterAvailableModules() {
            return ['has_goal', 'has_kpi']
        },
    },
}
</script>
